import type { ReactNode } from "react";

import type { LucideIcon } from "lucide-react";
import { motion } from "motion/react";

import { cn } from "@/lib/utils";

import { TONES, type StatTone } from "./stat-tile";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  icon?: LucideIcon;
  tone?: StatTone;
  actions?: ReactNode;
}

export function PageHeader({
  title,
  subtitle,
  icon: Icon,
  tone = "coral",
  actions,
}: PageHeaderProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: -6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
      className="flex flex-wrap items-center justify-between gap-3"
    >
      <div className="flex min-w-0 items-center gap-3">
        {Icon ? (
          <span
            className={cn(
              "grid size-11 shrink-0 place-items-center rounded-2xl shadow-sm",
              TONES[tone].icon,
            )}
          >
            <Icon className="size-5" aria-hidden />
          </span>
        ) : null}
        <div className="min-w-0">
          <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
          {subtitle ? <p className="text-muted-foreground text-sm">{subtitle}</p> : null}
        </div>
      </div>
      {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
    </motion.div>
  );
}
